// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 // baseURL: 'http://localhost:3007/support/',
  mqttURL:'dev2.venaqua.com',
  // mqttURL:'3.86.118.252',
  //baseURL: 'https://wegot-rwa01-usoh-production-alb2-1420980106.us-east-2.elb.amazonaws.com/support/'
   baseURL: '/support/'

};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
